export const environment = {
  production: true,
  //baseURL: 'http://localhost/srippv/',
  baseURL: 'http://ppvgroups.com/srippv_api/',
  authToken: 'ppvtech123'
};

